// extracted by mini-css-extract-plugin
module.exports = {"box":"PopupTemplateFour_box__1-eMC","box2":"PopupTemplateFour_box2__1C6cR"};